import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { ShoppingBag, TrendingUp, Handshake } from 'lucide-react';

const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const services = [
    {
      icon: ShoppingBag,
      title: 'Comprar',
      description: 'Adquira as peças mais desejadas do mercado com garantia de autenticidade.',
      image: 'https://images.pexels.com/photos/4276458/pexels-photo-4276458.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    },
    {
      icon: TrendingUp,
      title: 'Vender',
      description: 'Avaliação justa e transparente para o seu relógio de luxo.',
      image: 'https://images.unsplash.com/photo-1691865179028-1729b766a5cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB3YXRjaCUyMGJsYWNrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzUwMDU2MDF8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Handshake,
      title: 'Consignação',
      description: 'Cuidamos de todo o processo com máxima segurança, discrição e exclusividade.',
      image: 'https://images.unsplash.com/photo-1634113709155-5c2756711384?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB3YXRjaCUyMGJsYWNrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzUwMDU2MDF8MA&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <section
      id="servicos"
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 bg-[#121212]"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
        >
          <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
            Nossos Serviços
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-white tracking-tight">
            Como Podemos Ajudar
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                className="group relative overflow-hidden"
                initial={{ opacity: 0, y: 50 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                data-testid={`service-${index}`}
              >
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <div className="bg-[#C9A646] w-12 h-12 flex items-center justify-center mb-4">
                      <Icon size={24} className="text-black" />
                    </div>
                    <h3 className="font-serif text-2xl text-white mb-3">{service.title}</h3>
                    <p className="font-sans text-sm text-[#A3A3A3] leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
